import TwigBuilder from '../Library/TwigBuilder.js';
import {fetchJson} from '../Library/Fetch.js';

const FETCH_DEBOUNCE_MS = 300;

const initializedTextareas = new WeakSet();

const parseLabels = raw => {
    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

const applyShape = (instance, shape) => {
    instance.data           = {order: shape?.order ?? {}, store: shape?.store ?? {}};
    instance.fieldTypes     = shape?.types ?? {};
    instance.dateTimeFormat = shape?.dateTimeFormat ?? null;
};

const attachOne = (textarea, orderIdInput) => {
    const sampleUrlTemplate = textarea.dataset.sampleOrderUrl;
    const defaultShapeUrl   = textarea.dataset.defaultShapeUrl;

    if (!sampleUrlTemplate || !defaultShapeUrl) {
        return;
    }

    const instance = TwigBuilder.attach(textarea, {
        data:                 {},
        addButtonLabel:       textarea.dataset.twigAddLabel,
        addButtonIcon:        '{{',
        cornerButton:         true,
        labels:               parseLabels(textarea.dataset.twigLabels),
        placeholderToken:     textarea.dataset.placeholderToken,
        openMenuOnBraces:     true,
        integrationFieldUrls: JSON.parse(textarea.dataset.integrationFieldUrls),
        filters:              JSON.parse(textarea.dataset.twigFilters),
    });

    if (!instance) {
        return;
    }

    let defaultShape = null;
    let pendingTimer = null;
    let lastOrderId  = '';

    const loadDefault = async () => {
        if (defaultShape) {
            applyShape(instance, defaultShape);

            return;
        }

        const shape = await fetchJson(defaultShapeUrl);

        if (!shape) {
            return;
        }

        defaultShape = shape;
        applyShape(instance, shape);
    };

    const refresh = async () => {
        const orderId = orderIdInput?.value?.trim() ?? '';

        if (orderId === lastOrderId) {
            return;
        }

        lastOrderId = orderId;

        if (orderId === '') {
            await loadDefault();

            return;
        }

        const shape = await fetchJson(sampleUrlTemplate.replace('ORDER_ID', encodeURIComponent(orderId)));

        if (lastOrderId !== orderId) {
            return;
        }

        if (!shape) {
            await loadDefault();

            return;
        }

        applyShape(instance, shape);
    };

    loadDefault();

    if (orderIdInput) {
        orderIdInput.addEventListener('input', () => {
            clearTimeout(pendingTimer);
            pendingTimer = setTimeout(refresh, FETCH_DEBOUNCE_MS);
        });

        refresh();
    }
};

export const initializeTwigAssistant = scope => {
    scope.querySelectorAll('[data-twig-assistant]').forEach(textarea => {
        if (initializedTextareas.has(textarea)) {
            return;
        }

        initializedTextareas.add(textarea);

        const inputSelector = textarea.dataset.sampleOrderInput;
        const orderIdInput  = inputSelector
            ? document.querySelector(inputSelector)
            : null;

        attachOne(textarea, orderIdInput);
    });
};
